import { getRouteApi } from "@tanstack/react-router"

const layoutRoute = getRouteApi("/_auth/internal/feature-flags/$flagKey/_layout")

/** The flag page's key, shared by its tabs. */
export const useFlagPageKey = () => layoutRoute.useParams().flagKey
